<script>
import options from './HoldetsLys.options'
export default options
</script>

<template>
  <article class="kb-holdets-lys">
    <div class="kb-holdets-lys__header">
      <h2 class="kb-holdets-lys__title">
        {{ getLabel('title') }}
      </h2>
      <a :href="lysposeFormUrl" class="kb-button">{{ getLabel('donate') }}</a>
    </div>
    <ul class="kb-holdets-lys__list" v-for="lys, index in holdetsLys" :key="index">
      <li class="kb-holdets-lys__list-item">
        <DonationCard modifierClass="kb-holdets-lys--card-modifier" :result="lys"></DonationCard>
      </li>
    </ul>
    <div class="kb-holdets-lys__footer" v-if="showLoadMore">
      <button class="kb-button kb-button--full-color" @click="loadMore">{{ getLabel('showMore') }}</button>
    </div>
  </article>
</template>
